// Client-side model for the `get_app_init_details` eligibility signal. Kept separate
// from the onboarding machine so the mapping stays a pure, unit-testable function.

// Narrowed to the eligibility fields; the socket layer does not type responses per
// message. The sibling flat `eligible` boolean is deliberately not modelled — see
// mapEligibilityDecision.
export type AppInitDetailsResponse = {
  eligibility_info?: {
    eligible?: boolean | null;
    reason_code?: number | null;
    reason_code_description?: string | null;
  } | null;
};

export type EligibilityDecision = 'eligible' | 'ineligible' | 'unknown';

/**
 * Only an explicit `false` gates. Everything else — no response, no
 * `eligibility_info`, a non-boolean `eligible` — is `unknown` and carries the member
 * on, because the flat `eligible` bool is non-nullable on the wire and a tenant that
 * answers nothing still serialises `false`.
 */
export const mapEligibilityDecision = (
  response: AppInitDetailsResponse | undefined,
): EligibilityDecision => {
  const eligible = response?.eligibility_info?.eligible;

  if (typeof eligible !== 'boolean') return 'unknown';
  return eligible ? 'eligible' : 'ineligible';
};
